<app-header
  [canvasMode]="canvasMode"
  [loggedIn]="true"
  [canvasType]="canvasType"
  [fixedHeader]="true"
></app-header>

<div class="home-container">
  <h1 class="welcome-message">Publishing LIBRARY</h1>
  <div class="description">
    <span>Disclaimer: DO NOT MODIFY ANYTHING ON THIS PAGE. </span>Publishing has
    the potential to impact all customers. If you have questions regarding any
    information on this page, please contact the Product team.
  </div>
  <mat-tab-group
    class="HomeTab PublishTab"
    animationDuration="0ms"
    disableRipple
    style="min-height: 400px"
    *ngIf="accessAllowed"
    (selectedTabChange)="tabClick($event)"
  >
    <mat-tab label="All Items" id="recentTitle">
      <ng-template matTabContent>
        <div class="home-container" style="margin-top: 0px">
          <app-publish-canvas-list
            canvasType="report"
            [categories]="categories"
            [selections]="selectedReports"
            [toggleRefresh]="toggleRefresh"
            (selectionList)="reportCanvases($event)"
          ></app-publish-canvas-list>
        </div>
        <BR /><BR />
        <div class="home-container" style="margin-top: 0px">
          <app-publish-canvas-list
            canvasType="dashboard"
            [categories]="categories"
            [selections]="selectedDashboards"
            [toggleRefresh]="toggleRefresh"
            (selectionList)="dashboardCanvases($event)"
          ></app-publish-canvas-list>
        </div>
      </ng-template>
    </mat-tab>
    <mat-tab label="Scheduled Jobs" disabled>
      <ng-template matTabContent>
        <app-schedule-list></app-schedule-list>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>
